<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Datos de la Empresa <span class="text-subtitle2 text-grey"> </span>
                </div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm" @click="guardarDatos()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.nombreComercial" label="Nombre Comercial" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.razonSocial"
                            label="Razón social o Nombre de la Persona" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.rfc" label="RFC" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.telefono" mask="(###) ### - ####" label="Teléfono" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.email" label="Correo electrónico" />
                    </div>
                    <div class="col-12  ">
                        <q-input dense outlined v-model="form.sitioWeb" label="Sitio WEB" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
export default {
    name: 'DatosGenerales',
    data() {
        return {
            form: {
                nombre: '',
                razonSocial: '',
                rfc: '',
                telefono: '',
                email: ''
            }
        }
    },
    methods: {

        async guardarDatos() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.put('Configuracion/UpdateDatosGenerales/' + this.form._id, this.form)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {

                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al guardar datos' })
            }
        },

        async obtenerDatos() {
            try {
                const res = await axios.get('Configuracion/GetEmpresa')
                this.form = res.data
            } catch (err) {
                console.error(err)
            }
        }
    },
    mounted() {
        this.obtenerDatos()
    }
}
</script>